import {
  FETCH_COMMISSIONS,
  SET_COMMISSIONS,
  SAVE_COMMISSION_REQUEST,
  SAVE_COMMISSION_SUCCESS,
  SAVE_COMMISSION_FAILURE,
  COMMISSION_SET_FILTER,
  CommissionCategory,
} from './actions';

export interface CommissionState {
  list: CommissionCategory[];
  loading: boolean;
  saving: boolean;
  error?: string;
  filterName: string;
}

const initialState: CommissionState = {
  list: [],
  loading: false,
  saving: false,
  error: undefined,
  filterName: '',
};

export default function commissionManagerReducer(
  state: CommissionState = initialState,
  action: any
): CommissionState {
  switch (action.type) {
    case FETCH_COMMISSIONS:
      return { ...state, loading: true, error: undefined };

    case SET_COMMISSIONS:
      return { ...state, loading: false, list: action.payload ?? [] };

    case SAVE_COMMISSION_REQUEST:
      return { ...state, saving: true, error: undefined };

    case SAVE_COMMISSION_SUCCESS:
      return { ...state, saving: false };

    case SAVE_COMMISSION_FAILURE:
      return { ...state, saving: false, error: action.error };

    case COMMISSION_SET_FILTER:
      return { ...state, filterName: action.payload ?? '' };

    default:
      return state;
  }
}